import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { ErrorMessage, Field, Formik } from 'formik';
import { JwlField } from '../../../../components';
import * as Yup from 'yup';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import {
  GQLAccessoryInventory,
  GQLAccessoryInventoryUpdateInput
} from '@jewelutions/core-crm-server-api-client-domain';

interface IProps {
  accessoryInventory: GQLAccessoryInventory;
  onClose: (persisted: boolean) => void;
}

const AccessoryInventoryUpdateDialog: React.FC<IProps> = ({ accessoryInventory, onClose }) => {
  const initialValues = {
    inventoryReference: accessoryInventory.inventoryReference
  };
  const [
    updateAccessoryInventory,
    { error, loading }
  ] = GQLOperationBuilder.deliveryUnit.updateAccessoryInventory();

  const onSubmit = (props: any) => {
    const data: GQLAccessoryInventoryUpdateInput = {
      id: accessoryInventory.id,
      inventoryReference: props.inventoryReference
    };

    const mutationVariables = {
      input: data
    };

    updateAccessoryInventory({ variables: mutationVariables }).then(_result => {
      onClose(true);
    });
  };

  const onCancel = (_props: any) => {
    onClose(false);
  };

  const validationSchema = Yup.object().shape({
    inventoryReference: Yup.string().required('Inventory Reference is required')
  });

  return (
    <Dialog open={true} aria-labelledby="update-accessory-inventory">
      <DialogTitle>Update Accessory Inventory</DialogTitle>
      <DialogContent>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ values, handleSubmit }) => (
            <form onSubmit={handleSubmit} className="flex flex-col">
              <Field name={`inventoryReference`} component={JwlField} label="Inventory Reference" />

              <DialogActions>
                <Button color="primary" onClick={onCancel}>
                  Close
                </Button>
                <Button type="submit" color="primary" variant="contained">
                  Save
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default AccessoryInventoryUpdateDialog;
